import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession'
import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession'

import './slider.css'
import './shared.css'
import './index.css'

document.addEventListener('DOMContentLoaded', () => {
  console.log(window.location)
  // -------------------

  const slider = /** @type {HTMLInputElement} */ (
    document.getElementById('debtRange')
  )
  const output = /** @type {HTMLInputElement} */ (
    document.getElementById('debtOwed')
  )
  const incr_button = document.getElementById('incr')
  const decr_button = document.getElementById('decr')

  const yearSpan = document.querySelector('.year')
  if (yearSpan) {
    const currentYear = new Date().getFullYear()
    yearSpan.textContent = currentYear.toString()
  }

  if (!slider || !output || !incr_button || !decr_button) {
    console.error('One or more slider elements not found')
    return
  }

  function updateSlider() {
    const min = parseInt(slider.min) || 0
    const max = parseInt(slider.max) || 100
    const value = parseInt(slider.value)
    const percentage = ((value - min) / (max - min)) * 100
    slider.style.setProperty('--progress', `${percentage}%`)
    output.value = `$${parseInt(slider.value).toLocaleString()}`
  }

  output.addEventListener('blur', function () {
    const output_value = parseInt(output.value.replace(/[$ ,]/g, ''))
    output.value = `$${output_value.toLocaleString()}`
    slider.value = output_value.toString()
    updateSlider()
  })

  slider.addEventListener('input', updateSlider)
  updateSlider() // Initialize on load

  incr_button.onclick = function () {
    slider.value = (parseInt(slider.value) + 1000).toString()
    output.value = slider.value
    updateSlider()
  }
  decr_button.onclick = function () {
    slider.value = (parseInt(slider.value) - 1000).toString()
    output.value = slider.value
    updateSlider()
  }

  slider.oninput = function () {
    output.textContent = /** @type {HTMLInputElement} */ (this).value
    updateSlider()
  }

  // -------------------

  const SESSION_ID = 'usProMainFunnel'

  queryParamsToSession(SESSION_ID)

  const submit = document.querySelector('button[type="submit"]')
  if (!submit) {
    console.error('no submit button')
    return
  }

  submit.addEventListener('click', (e) => {
    e.preventDefault()
    updateSession(
      SESSION_ID,
      'debtOwed',
      parseInt(output.value.replace(/[$ ,]/g, '')).toString(),
    )
    updateSession(SESSION_ID, 'funnel', 'USFinancialPriority')
    window.location.href = `${window.location.hostname.includes('local') ? '/us-financial' : ''}/2/`
  })
})
